module.exports = __webpack_public_path__ + "static/media/question-circle-solid.36ab7574.svg";